<template>
    <ModalComponent
        :name="name"
        title="Rechazar familia"
        @close="$emit('cancel')"
    >
        <div class="tw:flex tw:flex-col tw:gap-4">
            <p class="tw:text-sm tw:text-gray-600">
                Indique el motivo por el que se rechaza la familia
                <strong v-if="familia" class="tw:text-gray-900">
                    {{ familia.nombre || 'Sin nombre' }}
                </strong>
            </p>

            <p class="tw:text-sm tw:text-amber-700 tw:bg-amber-50 tw:rounded tw:px-3 tw:py-2">
                Al rechazar la familia, sus miembros <strong>no podrán acceder</strong> a los beneficios de precios para familias.
            </p>

            <div class="tw:flex tw:flex-col tw:gap-1">
                <label class="tw:text-xs tw:font-semibold tw:uppercase tw:tracking-wider tw:text-gray-500">
                    Motivo <span class="tw:text-red-500">*</span>
                </label>
                <textarea
                    ref="textareaRef"
                    v-model="localMotivo"
                    class="tw:w-full tw:rounded-lg tw:border tw:border-gray-300 tw:px-3 tw:py-2 tw:text-sm tw:focus:border-blue-500 tw:focus:ring-1 tw:focus:ring-blue-500 tw:outline-none"
                    :class="{ 'tw:border-red-500': localError }"
                    rows="4"
                    placeholder="Describa el motivo del rechazo..."
                ></textarea>
                <span v-if="localError" class="tw:text-xs tw:text-red-500 tw:mt-1 tw:leading-tight" v-html="localError.replace(/\n/g, '<br>')"></span>
            </div>
        </div>

        <template #footer>
            <div class="tw:flex tw:justify-end tw:gap-2">
                <Button variant="secondary" @click="$emit('cancel')">Cancelar</Button>
                <Button variant="danger" :disabled="loading" @click="handleConfirm">
                    {{ loading ? 'Rechazando...' : 'Rechazar familia' }}
                </Button>
            </div>
        </template>
    </ModalComponent>
</template>

<script setup>
    import { ref, watch, nextTick } from 'vue'
    import ModalComponent from '@/modules/admin/ui/ModalComponent.vue'
    import Button from '@/modules/admin/ui/Button.vue'

    const props = defineProps({
        name: { type: String, default: 'motivo-rechazo' },
        familia: { type: Object, default: null },
        loading: { type: Boolean, default: false },
        error: { type: String, default: null },
    })

    const emit = defineEmits(['confirm', 'cancel'])

    const localMotivo = ref('')
    const localError = ref(null)
    const textareaRef = ref(null)

    watch(() => props.error, val => { localError.value = val })
    watch(() => props.familia, () => {
        localMotivo.value = ''
        localError.value = null
        nextTick(() => textareaRef.value?.focus())
    })

    function handleConfirm() {
        const trimmed = localMotivo.value.trim()
        if (!trimmed) {
            localError.value = 'El motivo es obligatorio'
            return
        }
        localError.value = null
        emit('confirm', trimmed)
    }
</script>
